"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openPositionsSelector = exports.openPositionsCountSelector = exports.closedPositionsSelector = void 0;
var _reselect = require("reselect");
var _instrumentPositionSelectors = require("../../selectors/instrumentPositionSelectors");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function transformPositions(positions, products, instruments) {
  return positions.map(function (position) {
    var borrowedProduct = products.find(function (p) {
      return position.BorrowedProductId === p.ProductId;
    });
    var positionProduct = products.find(function (p) {
      return position.PositionProductId === p.ProductId;
    });
    var quoteProduct = products.find(function (p) {
      return position.QuoteProductSymbol === p.Product;
    });
    var instrument = instruments.find(function (i) {
      return i.InstrumentId === position.PositionInstrumentId;
    });
    return _objectSpread(_objectSpread({}, position), {}, {
      instrument: instrument,
      borrowedProduct: borrowedProduct,
      positionProduct: positionProduct,
      quoteProduct: quoteProduct
    });
  });
}
var closedPositionsSelector = exports.closedPositionsSelector = (0, _reselect.createSelector)(function (state) {
  return state.margin.history.closedPositions;
}, function (state) {
  return state.apexCore.product.products;
}, function (state) {
  return (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
}, function (positions, products, instruments) {
  var transformedPositions = transformPositions(positions, products, instruments);
  return transformedPositions;
});
var openPositionsSelector = exports.openPositionsSelector = (0, _reselect.createSelector)(function (state) {
  return state.margin.history.openPositions;
}, function (state) {
  return state.apexCore.product.products;
}, function (state) {
  return (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
}, function (positions, products, instruments) {
  return transformPositions(positions, products, instruments).sort(function (a, b) {
    return new Date(b.DateOpened).valueOf() - new Date(a.DateOpened).valueOf();
  });
});
var openPositionsCountSelector = exports.openPositionsCountSelector = (0, _reselect.createSelector)(function (state) {
  return state.margin.history.openPositions;
}, function (positions) {
  return positions.length || 0;
});